module.exports = __webpack_public_path__ + "img/Full Color outlined_H.241a4fd3.png";